/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class User {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.authorities = [];
        }
    }

    /**
     * Whether the user has a given authority.
     *
     * @param {String} authority Authority code.
     * @return {boolean} True if the user has the given authority.
     */
    hasAuthority(authority) {
        return this.authorities.includes(authority);
    }
}

export {User};



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/User.js